export class ObjectFieldsChecker {
    public static throwIfInvalidFields<T>(object: T, fieldsToCheck: Array<keyof T>, objectName?: string): void {
        if (object == undefined) {
            throw new Error(`Object with name ${objectName} - validation failed.`);
        }
        for (const field of fieldsToCheck) {
            const value = object[field];
            if (value == undefined || (typeof (value) === "string" && value === "") || (typeof (value) === "number" && isNaN(value))) {
                throw new ObjectValidationError(field as string, objectName);
            }
        }
    }

    public static checkFields<T>(object: T, fieldsToCheck: Array<keyof T>): boolean {
        try {
            ObjectFieldsChecker.throwIfInvalidFields(object, fieldsToCheck);
            return true;
        }
        catch {
            return false;
        }
    }
}

export class ObjectValidationError extends Error {
    public constructor(
        public readonly fieldName: string,
        public readonly objectName?: string
    ) {
        super(`ObjectValidationError. Field ${fieldName} of object(${objectName}) is invalid`);
    }
}
